/** Teléfono y WhatsApp de la clínica (uso en topbar, contacto y FAB). */
export const CLINIC_PHONE = { href: 'tel:+5184607539', label: '(084) 607 539' };

export const WHATSAPP_PHONE = '51984403369';

export function buildWhatsAppUrl(message) {
  const text = String(message || '').trim();
  const base = `https://wa.me/${WHATSAPP_PHONE}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}
